import './page/llm-model-list';
import './page/llm-model-detail';

Shopware.Module.register('topdata-llm-connect-llm-model', {
    type: 'plugin',
    name: 'LLM Models',
    title: 'TopdataLlmConnectSW6.topdata-llm-connect-llm-model.title',
    description: 'TopdataLlmConnectSW6.topdata-llm-connect-llm-model.description',
    color: '#189eff',
    icon: 'default-badge-brand',

    routes: {
        list: {
            component: 'topdata-llm-connect-llm-model-list',
            path: 'list',
            meta: {
                privilege: 'system.plugin_maintenance',
            },
        },
        create: {
            component: 'topdata-llm-connect-llm-model-detail',
            path: 'create',
            meta: {
                privilege: 'system.plugin_maintenance',
            },
        },
        detail: {
            component: 'topdata-llm-connect-llm-model-detail',
            path: 'detail/:id',
            meta: {
                privilege: 'system.plugin_maintenance',
            },
        },
    },

    navigation: [{
        id: 'topdata-llm-connect-llm-model-list',
        label: 'TopdataLlmConnectSW6.topdata-llm-connect-llm-model.listTitle',
        color: '#189eff',
        path: 'topdata.llm.connect.llm.model.list',
        parent: 'topdata-llm-connect',
        position: 20,
    }],
});
